export default "__VITE_ASSET__DphNXQSx__"